﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";

export class FileUploadFormRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var $form = $element.closest('form');
    var $files = $form.find('input[type="file"]');
    var hasFileInputs = $files.length > 0;
    var elementIsFormOrSubmitable = $element.is('input[type="submit"]') || $element.is('form') || $element.is('button');

    var shouldHandle = hasFileInputs && elementIsFormOrSubmitable && $element.isEnabled() && $form.length != 0;
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    $form.trigger('formdatacollecting.rustig.remote');
    var form: any = $form[0];
    var data = new window['FormData'](form);

    options.contentType = false; // setting contentType and processData to false corrects jQuery's assumption about adding a Content-Type header for you. http://stackoverflow.com/questions/5392344/sending-multipart-formdata-with-jquery-ajax
    options.processData = false;
    options.type = options.type || $element.data('method') || $form.attr('method') || 'post';
    options.url = options.url || $element.data('url') || $form.attr('action');
    options.data = data;

      $form.trigger('remotesubmit.rustig.remote');
    Ajax.execute($element, options);
    return true;
  }
}
